import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';

import { Box, Heading, Link, Button, Paragraph } from 'components';

import withNewsletter from '../HOC';
import NewsletterSuccess from '../Success';

import './NewsletterSmall.scss';

const NewsletterSmall = ({ subscribed, refForm, handleSubmit, id }) => (
  <Box
    additionalClass={'newsletter-widget box--fitted'}
    backgroundColor={'carrara'}
  >
    <div className={'newsletter-small'}>
      <div className={`${subscribed && 'newsletter-small--subscribed'}`}>
        <Heading type={3} additionalClass={'newsletter-small__headline'}>
          {subscribed ? (
            <>
              Thank you for subscribing.
              <NewsletterSuccess />
            </>
          ) : (
            'Subscribe to Digital Shift Newsletter'
          )}
        </Heading>
        <Paragraph additionalClass={'newsletter-small__lead text--light'}>
          {subscribed
            ? 'We will send you a welcome email soon. In the meantime, you can explore our website.'
            : 'Get an inspirational insight into the practical application of a radically user-oriented design and disruptive software services shaping the digital economy 4.0, selected by co-CEOs of Boldare.'}
        </Paragraph>
      </div>
      <form
        className={`js-newsletter newsletter-small__form ${
          subscribed ? 'newsletter-small--hidden' : ''
        }`}
        onSubmit={handleSubmit}
        ref={refForm}
      >
        <Row>
          <Col sm={12} md>
            <input
              type={'email'}
              name={'email'}
              placeholder={'E-mail'}
              required
            />
            <Paragraph additionalClass={'newsletter-small__info text--light'}>
              We&#39;re committed to your privacy. Boldare uses the information
              you provide to us to contact you about our relevant content,
              products, and services. Read our{' '}
              <Link
                to={'/privacy-policy/'}
                id={'newsletter-small-privacy-policy'}
              >
                privacy policy.
              </Link>
            </Paragraph>
          </Col>
          <Col sm={12} md={3}>
            <Button
              id={`newsletter-submit-small--${id}`}
              additionalClass={'newsletter-submit-small'}
              type={'submit'}
              color={'pigeon-post'}
            >
              Subscribe
            </Button>
          </Col>
        </Row>
      </form>
    </div>
  </Box>
);

NewsletterSmall.propTypes = {
  subscribed: PropTypes.bool.isRequired,
  refForm: PropTypes.shape().isRequired,
  handleSubmit: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default withNewsletter(NewsletterSmall);
